import { useEffect, useState } from "react";
import { Seo } from "../components/Seo";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import api from "../lib/api";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((res) => setPosts(res.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="min-h-screen bg-obsidian pt-32 pb-24" data-testid="blog-list-page">
      <Seo
        title="Insights & Guides | Orion Services LLC"
        description="Engineering guides, fleet maintenance protocols, and hydraulic diagnostics from Orion Services LLC's technical team."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">Field Notes</span>
        <h1 className="font-display text-4xl sm:text-5xl uppercase text-white mt-2 mb-12">Insights & Guides</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="blog-list-grid">
          {posts.map((post, i) => (
            <motion.div key={post.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: i * 0.08 }}>
              <Link to={`/blog/${post.slug}`} data-testid={`blog-list-card-${post.slug}`} className="group block">
                <div className="aspect-[16/10] overflow-hidden rounded-md border border-amber-500/10 mb-4">
                  <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                </div>
                <span className="text-xs font-mono uppercase tracking-widest text-amber-light">{post.category}</span>
                <h3 className="text-lg font-bold text-white mt-2 leading-snug group-hover:text-amber-light transition-colors">{post.title}</h3>
                <p className="text-sm text-zinc-500 mt-2 line-clamp-2">{post.excerpt}</p>
                <div className="text-xs text-zinc-500 mt-3">{post.read_time} &middot; {post.author}</div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
